import { AfterViewInit, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { Observable, of } from 'rxjs';
import { UserHelper } from '@helpers/user.helper';
import { map } from 'rxjs/operators';

import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'language-changer-component',
  templateUrl: '../sharedTemplates/language.changer.component.html',
})
export class LanguageChangerComponent implements AfterViewInit {
  langDatas;
  langDatasArry = [];
  selectedLang = '';

  constructor(private _ApiService: ApiService, private _UserHelper: UserHelper, private _UiHelper: UiHelper, private _LocalizationService: LocalizationService) {
    this._UiHelper.setNavbarTitle('language', false);
  }

  okClick(): void {
    this._LocalizationService.changeLang(this.selectedLang);
  }

  selectionChange(x) {
    this._LocalizationService.changeLang(x);
  }

  ngAfterViewInit() {
    this.selectedLang = this._LocalizationService.LANGCODE;
    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });

    if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();

    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();
  }
}
